import { httpClient } from '@/config/httpClient';

export type ComplianceProps = {
  batchId: string;
  comment: string;
  file?: File;
};

export async function postCompliance(data: ComplianceProps) {
  const formData = new FormData();

  if (data.file) formData.append('file', data.file as File);
  formData.append('comment', data.comment);
  formData.append('batchId', String(data.batchId));

  return httpClient.post('/batch/compliance', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
